const createQuery = () => `
  ... on CompanyStatsWidget {
    id
  }
`

export default createQuery
